import { Pipe, PipeTransform } from '@angular/core';
import { SecondsToTimeService } from '../fi-services/seconds-to-time.service';

@Pipe({
    name: 'fiSecondsToTime',
    standalone: false,
})
export class SecondsToTimePipe implements PipeTransform {
    constructor(private secondsToTimeService: SecondsToTimeService) {}

    transform(value: number, args?: any): any {
        return this.secondsToTimeService.getTime(value);
    }
}
